"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLinesQuery = exports.useIsDesktop = exports.useDispatchTypesQuery = exports.useDispatchMachinesQuery = void 0;
var _react = require("react");
var _lodash = require("lodash");
var _queries = require("../../api/dispatch/queries");
var _client = require("@apollo/client");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var LIMIT = 200;
var queryOptions = {
  variables: {
    offset: 0,
    limit: LIMIT
  },
  fetchPolicy: 'cache-and-network',
  nextFetchPolicy: 'cache-first'
};
var useIsDesktop = exports.useIsDesktop = function useIsDesktop() {
  var DESKTOP_WIDTH_LIMIT = 768;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDesktop = _useState2[0],
    setIsDesktop = _useState2[1];
  var handleResize = (0, _react.useCallback)(function () {
    var isDesktop = window.innerWidth >= DESKTOP_WIDTH_LIMIT;
    setIsDesktop(isDesktop);
  }, [setIsDesktop]);
  (0, _react.useEffect)(function () {
    var resizeListener = window.addEventListener('resize', (0, _lodash.debounce)(handleResize, 100));
    return function () {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);
  return isDesktop;
};
var fetch = function fetch(query, offset, field, setOffset, setDone) {
  return query({
    variables: {
      offset: offset,
      limit: LIMIT
    },
    updateQuery: function updateQuery(previousData, _ref) {
      var _previousData$field, _fetchMoreResult$fiel;
      var fetchMoreResult = _ref.fetchMoreResult;
      setOffset(offset);
      var previousResults = previousData === null || previousData === void 0 || (_previousData$field = previousData[field]) === null || _previousData$field === void 0 ? void 0 : _previousData$field.results;
      var updatedResults = fetchMoreResult === null || fetchMoreResult === void 0 || (_fetchMoreResult$fiel = fetchMoreResult[field]) === null || _fetchMoreResult$fiel === void 0 ? void 0 : _fetchMoreResult$fiel.results;
      var isLastPage = updatedResults.length < LIMIT;
      if (isLastPage) {
        setDone(true);
        return previousData;
      }
      return _objectSpread(_objectSpread({}, previousData), {}, _defineProperty({}, field, _objectSpread(_objectSpread({}, previousData[field]), {}, {
        results: [].concat(_toConsumableArray(previousResults), _toConsumableArray(updatedResults))
      })));
    }
  });
};
var useLinesQuery = exports.useLinesQuery = function useLinesQuery() {
  var _useQuery = (0, _client.useQuery)(_queries.GetLines, queryOptions),
    data = _useQuery.data,
    linesLoading = _useQuery.loading,
    fetchMore = _useQuery.fetchMore;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    done = _useState4[0],
    setDone = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    fetchingMore = _useState6[0],
    setFetchingMore = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    lastOffset = _useState8[0],
    setLastOffset = _useState8[1];
  var lines = (data === null || data === void 0 ? void 0 : data.dispatchLines.results) || [];
  var fetchMoreLines = function fetchMoreLines() {
    if (done || fetchingMore) {
      return;
    }
    setFetchingMore(true);
    var offset = lastOffset + LIMIT;
    fetch(fetchMore, offset, 'dispatchLines', setLastOffset, setDone)["finally"](function () {
      setFetchingMore(false);
    });
  };
  return {
    lines: lines,
    linesLoading: linesLoading,
    fetchMoreLines: fetchMoreLines,
    done: done
  };
};
var useDispatchTypesQuery = exports.useDispatchTypesQuery = function useDispatchTypesQuery() {
  var _useQuery2 = (0, _client.useQuery)(_queries.GetDispatchTypes, queryOptions),
    data = _useQuery2.data,
    typesLoading = _useQuery2.loading,
    fetchMore = _useQuery2.fetchMore;
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    done = _useState10[0],
    setDone = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    fetchingMore = _useState12[0],
    setFetchingMore = _useState12[1];
  var _useState13 = (0, _react.useState)(0),
    _useState14 = _slicedToArray(_useState13, 2),
    lastOffset = _useState14[0],
    setLastOffset = _useState14[1];
  var dispatchTypes = (data === null || data === void 0 ? void 0 : data.dispatchTypes.results) || [];
  var fetchMoreTypes = function fetchMoreTypes() {
    if (done || fetchingMore) {
      return;
    }
    setFetchingMore(true);
    var offset = lastOffset + LIMIT;
    fetch(fetchMore, offset, 'dispatchTypes', setLastOffset, setDone)["finally"](function () {
      setFetchingMore(false);
    });
  };
  return {
    dispatchTypes: dispatchTypes,
    typesLoading: typesLoading,
    fetchMoreTypes: fetchMoreTypes,
    done: done
  };
};
var useDispatchMachinesQuery = exports.useDispatchMachinesQuery = function useDispatchMachinesQuery() {
  var _useLazyQuery = (0, _client.useLazyQuery)(_queries.GetDispatchMachines, queryOptions),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    dispatchMachinesQuery = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    data = _useLazyQuery2$.data,
    machinesLoading = _useLazyQuery2$.loading,
    fetchMore = _useLazyQuery2$.fetchMore;
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    done = _useState16[0],
    setDone = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    fetchingMore = _useState18[0],
    setFetchingMore = _useState18[1];
  var _useState19 = (0, _react.useState)(0),
    _useState20 = _slicedToArray(_useState19, 2),
    lastOffset = _useState20[0],
    setLastOffset = _useState20[1];
  var dispatchMachines = (data === null || data === void 0 ? void 0 : data.dispatchMachines.results) || [];
  var fetchMoreMachines = function fetchMoreMachines() {
    if (done || fetchingMore) {
      return;
    }
    setFetchingMore(true);
    var offset = lastOffset + LIMIT;
    fetch(fetchMore, offset, 'dispatchMachines', setLastOffset, setDone)["finally"](function () {
      setFetchingMore(false);
    });
  };
  return {
    dispatchMachinesQuery: dispatchMachinesQuery,
    dispatchMachines: dispatchMachines,
    machinesLoading: machinesLoading,
    fetchMoreMachines: fetchMoreMachines,
    done: done
  };
};
//# sourceMappingURL=hooks.js.map